export default function AutoFundraiserLogo({ compact = false }) {
  return (
    <svg
      className={compact ? "af-brand-svg af-brand-svg-compact" : "af-brand-svg"}
      viewBox="0 0 520 170"
      role="img"
      aria-label="Auto Fundraiser"
    >
      <rect width="520" height="170" rx="18" fill="#ffffff" />
      <g transform="translate(18 18)">
        <path d="M10 94 C28 91 44 84 58 75 C73 65 86 54 100 40" fill="none" stroke="#0b8f77" strokeWidth="10" strokeLinecap="round" />
        <rect x="26" y="75" width="13" height="30" rx="3" fill="#0b8f77" />
        <rect x="48" y="61" width="13" height="44" rx="3" fill="#0b8f77" />
        <rect x="70" y="46" width="13" height="59" rx="3" fill="#0b8f77" />
        <path d="M99 18 L118 40 H107 V91 H93 V40 H82 Z" fill="#0b8f77" />
        <path d="M15 105 C39 111 58 119 76 131 C85 137 94 137 101 130 L117 115" fill="none" stroke="#082b63" strokeWidth="10" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M117 115 L137 130 C144 136 153 136 160 129" fill="none" stroke="#0b8f77" strokeWidth="10" strokeLinecap="round" />
        <path d="M90 120 L103 133 M81 126 L94 139 M72 132 L84 144" stroke="#082b63" strokeWidth="7" strokeLinecap="round" />
        <path d="M118 108 C133 98 145 83 154 63 L154 111 L137 121 Z" fill="#082b63" opacity=".96" />
      </g>
      <text x="205" y="73" fontFamily="Inter, Arial, sans-serif" fontSize="58" fontWeight="700" fill="#0b8f77">Auto</text>
      <text x="205" y="137" fontFamily="Inter, Arial, sans-serif" fontSize="58" fontWeight="700" fill="#082b63">Fundraiser</text>
    </svg>
  );
}
